import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export const useInfiniteQueryGetMembershipSubscriptionPreviousAsMember = ({
  api,
}: {
  api: ApiType;
}) =>
  useInfiniteQuery({
    queryKey: memberAsMemberQueryKeys.getMembershipSubscriptionPrevious(),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.profileApi.getMembershipSubscriptionPrevious({
          nextPageToken: pageParam,
          limit: 20,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    initialPageParam: undefined,
  });
